module.exports = __webpack_public_path__ + "static/media/tickNewSkinny.6787ca77.svg";